import { getParts } from "../../../../utils/helpers";
import { RenderPart } from "./RenderPart";

interface OptionCardProps {
    selected?: boolean;
    correct?: boolean;
    changeColor?: boolean;
    review?: boolean;
    onClick: any;
    src: string;
    textStyle?: any;
}

export const OptionCard: React.FC<OptionCardProps> = ({
    selected = true,
    correct = true,
    review = true,
    onClick,
    src,
    textStyle = {},
    changeColor,
}) => {
    return (
        <div
            onClick={onClick}
            className={
                "border pl-4 pr-8 py-4 mt-3 rounded-md sort-item" +
                " " +
                (selected || review
                    ? " border-dark-purple"
                    : "border-bright-gray") +
                " " +
                (review
                    ? correct
                        ? "bg-nyanza bg-opacity-100"
                        : "bg-red bg-opacity-10"
                    : changeColor
                    ? "bg-corn-silk"
                    : "bg-pastel-yellow bg-opacity-10")
            }
        >
            {getParts(src).map((part, pIndex) => (
                <RenderPart part={part} key={pIndex} textStyle={textStyle} />
            ))}
        </div>
    );
};
